import React, { useContext, useEffect, useRef } from 'react';
import gsap from 'gsap';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import ModalHeader from 'components/FiltersModal/Header';
import { Constrain } from 'components/FiltersModal/components';
import CustomFilters from '../CustomFilters';
import { CONTAINERS } from 'contexts/CruiseSearchContext/constants';

function Custom() {
	const { globalization } = useContext<any>(CruiseSearchContext);

	const { filtersDictionary } = globalization?.dictionaries || {};
	const { labelUniqueOffers, navSpecialSailings } = filtersDictionary;

	const wrapperRef = useRef<any>();

	useEffect(() => {
		gsap.to(wrapperRef.current, {
			opacity: 1,
			x: 0,
			duration: 0.5,
			delay: 0.1,
			ease: 'cubic-bezier(0,0,0,0)',
		});
		gsap.to(wrapperRef.current?.children || [], {
			opacity: 1,
			x: 0,
			duration: 0.35,
			stagger: 0.05,
			delay: 0.1,
			ease: 'cubic-bezier(0,0,0,0)',
		});
	}, []);

	return (
		<>
			<ModalHeader title={navSpecialSailings} />
			<Constrain className='no-top-padding'>
				<CustomFilters title={labelUniqueOffers} keyName={CONTAINERS.FILTER_CUSTOM} />
			</Constrain>
		</>
	);
}

Custom.propTypes = {};

export default Custom;
